import ApiService from './api.service';

// eslint-disable-next-line import/prefer-default-export
export async function getPatientTypes() {
  const path = `${window.ambulnzConfig.tenantedRestApiUrl}/PatientTypes`;
  const response = await ApiService.get(path);

  return response.json();
}
